import { AxiosError } from 'axios';
import { Dispatch } from 'redux';
import {
  fetchWalletBalanceError,
  fetchWalletBalanceLoading,
  fetchWalletBalanceSuccess
} from 'appRedux/actions';
import { ApiClient } from 'services/ApiClient';
import { IWalletBalanceResponse } from 'interfaces';

export const getWalletBalance = (currency: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchWalletBalanceLoading());
    try {
      const { data } = await ApiClient.get<IWalletBalanceResponse>(
        `/account/wallets/${currency}/balance`
      );
      return dispatch(
        fetchWalletBalanceSuccess({
          ...data.data,
          formatted_balance: data.formatted_balance
        })
      );
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error?.response?.data?.message;
        return dispatch(fetchWalletBalanceError(errorMessage));
      } else if (error instanceof Error) {
        return dispatch(fetchWalletBalanceError(error.message));
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  };
};
